module.exports = __webpack_public_path__ + "img/ssyx_10.24f3c200.jpg";